import useSWR from 'swr'

import {patchHeaders, fetcher} from '../../api'
import {camelizeResult, dineroMoneyObjects} from '../../api/serializer'
import {useRails} from '../contexts/rails'

export const COMPLETE = 'complete'
export const DECISION_PENDING_ACKNOWLEDGED = 'decision_pending_acknowledged'
export const DECISION_SUPPORTED = 'decision_supported'

export const useAcquisitionDecision = (currentState) => {
  const {authenticityToken, organisation, refreshInterval} = useRails()

  const fallbackData = {
    currentState,
    pendingReasonKeys: [],
    meta: {
      progressPercentage: 0,
    },
  }

  const url = organisation.currentSupplier.id
    ? `/api/suppliers/${organisation.currentSupplier.id}/acquisition_decision`
    : null

  const {data, error, isLoading, mutate} = useSWR(url, fetcher, {
    use: [camelizeResult, dineroMoneyObjects],
    fallbackData,
    refreshInterval,
  })

  const patch = async (newState) => {
    await fetcher(
      url,
      patchHeaders({
        authenticityToken,
        body: {
          transition_to: newState,
        },
      }),
    )
  }

  const transitionTo = (newState) =>
    mutate(patch(newState), {
      optimisticData: {
        ...data,
        currentState: newState,
      },
    })

  return {data, transitionTo, error, isLoading}
}
